module.exports = __webpack_public_path__ + "static/media/bill_green.fb814ed1.svg";